import { render, staticRenderFns } from "./DocFaceLibraryDelete.vue?vue&type=template&id=3624642f&scoped=true"
import script from "./DocFaceLibraryDelete.vue?vue&type=script&lang=js"
export * from "./DocFaceLibraryDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3624642f",
  null
  
)

export default component.exports